<script setup>
import { onMounted, ref } from "vue";
import { businessRequest, savedRequest, updateRequest } from '../api/business';
import { invocer } from '../api/invoicer';
import { municipality, contries } from '../api/technicalAnnex';

import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Dialog from 'primevue/dialog';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Toast from 'primevue/toast';
import Select from 'primevue/select';
import { FilterMatchMode } from '@primevue/core/api';
import { useToast } from "primevue/usetoast";


const activeSpinner = ref(false)
const columns = [
  { field: 'nombre', header: 'Nombre' },
  { field: 'id_facturador', header: 'IdFacturador' },
  { field: 'direccion', header: 'Dirección' },
  { field: 'nombre_comercial', header: 'Nombre Comercial' }
];

const toast = useToast();
const dataSource = ref([]);
const valuesResolution = ref([null]);
const valuesUbication = ref([null]);
const visible = ref(false);
const modalCreated = ref(false);
const modalUpdate =  ref(false);
const title = ref('');

//ObjetsArray Facturadores
const clerk = ref([]);

//ObjetsArray Municipios && Departamentos
const munDep = ref([]);
const municipalities = ref([]);
const departments = ref([]);

//ObjetsArray Paises
const contry = ref([]);


//Source of Saved Data
const id = ref(0)
const selectedCleck = ref(null);
const name = ref('');
const password = ref('');
const hashPassword = ref('');
const trade_name = ref('');
const prefix = ref('');
const resolution_number = ref('');
const technical_key = ref('');
const consecutive = ref(0);
const from_date = ref('');
const to_date = ref('');
const from_rank = ref(0);
const to_rank = ref(0);
const address = ref('');
const zip_code = ref(0);
const selectedCountry = ref(null);
const selectedCodeCountry = ref(null);
const selectedDeparment = ref(null);
const selectedCodeDeparment = ref(null);
const selectedMunicipaly = ref(null);
const selectedCodeMunicipaly = ref(null);


const clearData = () => {
  selectedCleck.value = null
  name.value = ''
  password.value = ''
  trade_name.value = ''
  prefix.value = ''
  resolution_number.value = ''
  technical_key.value = ''
  consecutive.value = 0
  from_date.value = ''
  to_date.value = ''
  from_rank.value = 0
  to_rank.value = 0
  address.value = ''
  zip_code.value = 0
  selectedCountry.value = null
  selectedCodeCountry.value = null
  selectedDeparment.value = null
  selectedCodeDeparment.value = null
  selectedMunicipaly.value = null
  selectedCodeMunicipaly.value = null
}

const selectedCodeDept = () => {
  let code = selectedDeparment.value.codigo != undefined ? selectedDeparment.value.codigo : selectedDeparment.value;
  selectedCodeDeparment.value =  code
}

const selectedCodeMun = () => {
  let code = selectedMunicipaly.value.codigo != undefined ? selectedMunicipaly.value.codigo : selectedMunicipaly.value;
  selectedCodeMunicipaly.value = code;
}

const selectContryCode = () => {
  let code = selectedCountry.value.codigo_numerico != undefined ? selectedCountry.value.codigo_numerico : selectedCountry.value;
  selectedCodeCountry.value  = code
}

const loadBusiness = async () => {
  activeSpinner.value = true;
  try {
    let result = await businessRequest()
    dataSource.value = result.data.data;
    activeSpinner.value = false;
  } catch (error) {
    console.log(error);
  }
}

const showMoreInfo = (data) => {
  visible.value = true;
  title.value = data.nombre;
  valuesResolution.value = [
    {name : "prefijo", value: data.prefijo},
    {name : "Resolucion", value: data.numero_resolucion},
    {name : "Fecha Inicial", value: data.fecha_desde},
    {name : "Fecha Final", value: data.fecha_hasta},
    {name : "Rango Inicial", value: data.rango_desde},
    {name : "Rango Final", value: data.rango_hasta},
    {name : "Consecutivo", value: data.consecutivo},
    {name : "Clave Tecnica", value: data.clave_tecnica}
  ]

  valuesUbication.value = [
    {name : "Cod. Postal", value: data.codigo_postal},
    {name : "Municipio", value: data.ciudad_municipio},
    {name : "Cod. Municipio", value: data.codigo_municipio},
    {name : "Departamento", value: data.departamento},
    {name : "Cod. Departamento", value: data.codigo_departamento},
    {name : "Pais", value: data.pais},
    {name : "Cod. Pais", value: data.codigo_pais}
  ]
}

const filters = ref({
    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
});

const department = () => {
  departments.value = munDep.value.reduce((acc, curr) => {
    const existing = acc.find(item => item.departamento === curr.nombre_departamento);
    return existing ? acc : [...acc, { codigo: curr.codigo_departamento, departamento: curr.nombre_departamento }];
  }, []);
}

const municipalityAndCode = () => {
  selectedCodeDept();
  selectedCodeMunicipaly.value = null;
  municipalities.value = [];
  const code = selectedCodeDeparment.value
  municipalities.value = munDep.value
  .filter(item => item.codigo_departamento === code)
  .map(item => ({
    codigo: item.codigo_municipio,
    municipio: item.nombre_municipio
  }));
}

const loadNecesaryDataForm = async() => {
  let dataClerk = await invocer();
  let municipalitiesAndDepartments = await municipality();
  let datacontries = await contries();
  clerk.value = dataClerk.data.data;
  munDep.value = municipalitiesAndDepartments.data.data;
  contry.value = datacontries.data.data;
}

const showModalCreate = async() => {
  clearData();
  modalCreated.value = true;
  await loadNecesaryDataForm();
  department();
}

const editProduct = async(data) => {
  await loadNecesaryDataForm();
  modalUpdate.value = true;
  department();
  
  //loadForm
  id.value = data.id;
  selectedCleck.value = data.id_facturador;
  name.value = data.nombre;
  password.value = '';
  hashPassword.value = data.password;
  trade_name.value = data.nombre_comercial;
  prefix.value = data.prefijo
  resolution_number.value = data.numero_resolucion
  technical_key.value = data.clave_tecnica
  consecutive.value = data.consecutivo
  from_date.value = data.fecha_desde
  to_date.value = data.fecha_hasta
  from_rank.value = data.rango_desde
  to_rank.value = data.rango_hasta
  address.value = data.direccion
  zip_code.value = data.codigo_postal
  selectedCountry.value = parseInt(data.codigo_pais)
  selectedCodeCountry.value = data.codigo_pais
  selectedDeparment.value =  data.codigo_departamento.startsWith('0') ? data.codigo_departamento : parseInt(data.codigo_departamento)
  selectedCodeDeparment.value = data.codigo_departamento
  municipalityAndCode();
  selectedMunicipaly.value = data.codigo_municipio.startsWith('0') ? data.codigo_municipio : parseInt(data.codigo_municipio);
  selectedCodeMunicipaly.value = data.codigo_municipio
}

const save = async() => {
  let data = {
    id: id.value,
    facturador: selectedCleck.value,
    nombre: name.value,
    password: password.value,
    hash_password : hashPassword.value,
    direccion : address.value,
    comercial: trade_name.value,
    admin: '',
    prefijo: prefix.value,
    resolucion: resolution_number.value,
    fecha_desde: from_date.value,
    fecha_hasta: to_date.value,
    rango_desde: from_rank.value,
    rango_hasta: to_rank.value,
    consecutivo: consecutive.value,
    clave_tecnica: technical_key.value,
    codigo_postal: zip_code.value,
    codigo_municipio: selectedCodeMunicipaly.value,
    ciudad_municipio: selectedMunicipaly.value.municipio ,
    codigo_departamento: selectedCodeDeparment.value,
    departamento:selectedDeparment.value.departamento ,
    codigo_pais: selectedCodeCountry.value,
    pais:selectedCountry.value.nombre_comun,
    config: ''
  }

  let res = await savedRequest(data);
  if(res.status == 201 && res.data.message == 'saved successfully bussines'){
    modalCreated.value = false;
    toast.add({ severity: 'success', summary: 'Punto De Venta '+trade_name.value, detail: 'Creado Correctamente', life: 4000 });
    loadBusiness();
    clearData();
  }
}

const update = async() => {
  const codeMunicipaly = selectedMunicipaly.value;
  const codeCountry = selectedCodeCountry.value;
  const [{nombre_municipio,nombre_departamento}] = munDep.value.filter(item => item.codigo_municipio == codeMunicipaly)
  const [{nombre_comun}] = contry.value.filter(item => item.codigo_numerico == codeCountry)

  let data = {
    id: id.value,
    facturador: selectedCleck.value,
    nombre: name.value,
    password: password.value,
    hash_password : hashPassword.value,
    direccion : address.value,
    comercial: trade_name.value,
    admin: '',
    prefijo: prefix.value,
    resolucion: resolution_number.value,
    fecha_desde: from_date.value,
    fecha_hasta: to_date.value,
    rango_desde: from_rank.value,
    rango_hasta: to_rank.value,
    consecutivo: consecutive.value,
    clave_tecnica: technical_key.value,
    codigo_postal: zip_code.value,
    codigo_municipio: selectedCodeMunicipaly.value,
    ciudad_municipio: nombre_municipio,
    codigo_departamento: selectedCodeDeparment.value,
    departamento: nombre_departamento,
    codigo_pais: selectedCodeCountry.value,
    pais: nombre_comun,
    config: ''
  }
  let res = await updateRequest(data);
  if(res.status == 201 && res.data.message == 'update successfully bussines'){
    modalUpdate.value = false;
    toast.add({ severity: 'info', summary: 'Punto De Venta '+trade_name.value, detail: 'Actualizado Correctamente', life: 4000 });
    loadBusiness();
    clearData();
  }
}

onMounted(() => {
  loadBusiness();
});
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Configuracion Puntos De Venta</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2 mt-4">
      <Toolbar class="mb-6 m-3">
        <template #start>
          <Button label="Crear" icon="pi pi-plus" severity="success" class="m-2"  @click="showModalCreate"/>
          <Button label="Recargar" icon="pi pi-replay" severity="info" class="m-2"  @click="loadBusiness"/>
          <Toast />
        </template>
        <template #end>
          <IconField>
                <InputIcon>
                    <i class="pi pi-search" />
                </InputIcon>
                <InputText v-model="filters['global'].value"  placeholder="Keyword Search" />
            </IconField>
        </template>
      </Toolbar>

      <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
      </div>

      <DataTable 
        v-if="!activeSpinner"
        class="m-3" 
        :value="dataSource" 
        :paginator="true" 
        :rows="5"
        :rowsPerPageOptions="[5, 10, 20, 50]" 
        :filters="filters"
        stripedRows 
        resizableColumns 
        columnResizeMode="fit" 
        showGridlines 
        tableStyle="min-width: 50rem"
      >
        <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column>
        <Column :exportable="false" style="min-width: 1rem">
          <template #body="slotProps">
              <Button icon="pi pi-pencil" outlined rounded class="mr-2" severity="info" @click="editProduct(slotProps.data)" />
              <Button icon="pi pi-eye" outlined rounded class="mr-2" severity="success" @click="showMoreInfo(slotProps.data)" />
          </template>
        </Column>
      </DataTable>

      <!-- //---Modal View More---// -->
      <Dialog v-model:visible="visible" position="topright" modal :header="title" :style="{ width: '100%' }">
        <Splitter style="height: 435px" class="mb-4">
            <SplitterPanel class="flex items-center justify-center text-center"  :size="130" > 
              <h5 class="text-center mt-2">Resolucion</h5>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,id) in valuesResolution" :key="id">
                    <th>{{ item.name }}</th>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </table>
            </SplitterPanel>
            <SplitterPanel class="flex items-center justify-center"> 
              <h5 class="text-center mt-2">Ubicacion</h5>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,id) in valuesUbication" :key="id">
                    <th>{{ item.name }}</th>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </table>
            </SplitterPanel>
        </Splitter>
      </Dialog>

      <!-- //---Modal Create---// -->
      <Dialog v-model:visible="modalCreated" position="top" modal :header="title" :style="{ width: '100%' }">
        <template #header>
          <div class="inline-flex items-center justify-center gap-2">
              <span class="font-bold whitespace-nowrap">Guardar Punto De Venta</span>
          </div>
        </template>
        <!-- //---Form---// -->
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <label for="exampleFormControlInput1" class="form-label">Facturador</label>
              <Select  v-model="selectedCleck" :options="clerk" filter optionValue="id_facturador" optionLabel="razon_social"  class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="name" class="form-label">Nombre</label>
                <input type="text" v-model="name" class="form-control inputCreate" id="name" placeholder="mimos-santafe">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="password" class="form-label">Contraseña</label>
                <input type="text" v-model="password" class="form-control inputCreate" id="password">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="trade_name" class="form-label">Nombre Comercial</label>
                <input type="text" v-model="trade_name" class="form-control inputCreate" id="trade_name" >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="prefix" class="form-label">Prefijo</label>
                <input type="text" v-model="prefix" class="form-control inputCreate" id="prefix">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="resolution_number" class="form-label">Numero Resolucion</label>
                <input type="number" v-model="resolution_number" class="form-control inputCreate" id="resolution_number">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="technical_key" class="form-label">Clave Tecnica</label>
                <input type="text" v-model="technical_key" class="form-control inputCreate" id="technical_key">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="consecutive" class="form-label">Consecutivo</label>
                <input type="number" v-model="consecutive" class="form-control inputCreate" id="consecutive" >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="from_date" class="form-label">Fecha Desde</label>
                <input type="date" v-model="from_date" class="form-control inputCreate" id="from_date">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="to_date" class="form-label">Fecha Hasta</label>
                <input type="date" v-model="to_date" class="form-control inputCreate" id="to_date">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="from_rank" class="form-label">Rango Desde</label>
                <input type="number" v-model="from_rank" class="form-control inputCreate" id="from_rank">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="to_rank" class="form-label">Rango Hasta</label>
                <input type="number" v-model="to_rank" class="form-control inputCreate" id="to_rank">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="address" class="form-label">Dirección</label>
                <input type="email" v-model="address" class="form-control inputCreate" id="address">
              </div>
            </div>            
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Codigo Postal</label>
                <input type="number" v-model="zip_code" class="form-control inputCreate" id="zip_code">
              </div>
            </div>
            <div class="col-md-3">
              <label for="exampleFormControlInput1" class="form-label">Pais</label>
              <Select  v-model="selectedCountry" @change="selectContryCode" :options="contry" filter optionLabel="nombre_comun" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="code_contry" class="form-label">Codigo Pais</label>
                <input type="number" :value="selectedCodeCountry" class="form-control inputCreate"  disabled id="code_contry">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="selectedDeparment" class="form-label">Departamento</label>
              <Select  v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" filter optionLabel="departamento" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="ciudad_municipio" class="form-label">Codigo Departamento</label>
                <input type="number" :value=selectedCodeDeparment class="form-control inputCreate" disabled  id="ciudad_municipio">
              </div>
            </div>
            <div class="col-md-3">
              <label for="selectedMunicipaly" class="form-label">Municipio</label>
              <Select  v-model="selectedMunicipaly" @change="selectedCodeMun" :options="municipalities" filter optionLabel="municipio" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="rangeTo_number" class="form-label">Codigo Municipio</label>
                <input type="number" :value="selectedCodeMunicipaly" class="form-control inputCreate" disabled  id="rangeTo_number">
              </div>
            </div>
          </div>
        </div>
        <!-- //---Form---// -->
        <template #footer>
            <Button label="Cancel" text severity="danger" @click="modalCreated = false" autofocus />
            <Button label="Guardar" outlined severity="primary" @click="save" autofocus />
        </template>
      </Dialog>

      <!-- //---Modal Update---// -->
      <Dialog v-model:visible="modalUpdate" position="top" modal :header="title" :style="{ width: '100%' }">
        <template #header>
          <div class="inline-flex items-center justify-center gap-2">
              <span class="font-bold whitespace-nowrap">Actualizar Punto De Venta</span>
          </div>
        </template>
        <!-- //---Form---// -->
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <label for="id_facturador" class="form-label">Facturador</label>
              <Select  v-model="selectedCleck" :options="clerk"  filter optionValue="id_facturador" optionLabel="razon_social" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="name" class="form-label">Nombre</label>
                <input type="text" v-model="name" class="form-control inputCreate" id="name" placeholder="mimos-santafe">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="password" class="form-label">Contraseña</label>
                <input type="text" v-model="password" class="form-control inputCreate" id="password">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="trade_name" class="form-label">Nombre Comercial</label>
                <input type="text" v-model="trade_name" class="form-control inputCreate" id="trade_name" >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="prefix" class="form-label">Prefijo</label>
                <input type="text" v-model="prefix" class="form-control inputCreate" id="prefix">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="resolution_number" class="form-label">Numero Resolucion</label>
                <input type="number" v-model="resolution_number" class="form-control inputCreate" id="resolution_number">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="technical_key" class="form-label">Clave Tecnica</label>
                <input type="text" v-model="technical_key" class="form-control inputCreate" id="technical_key">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="consecutive" class="form-label">Consecutivo</label>
                <input type="number" v-model="consecutive" class="form-control inputCreate" id="consecutive" >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="from_date" class="form-label">Fecha Desde</label>
                <input type="date" v-model="from_date" class="form-control inputCreate" id="from_date">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="to_date" class="form-label">Fecha Hasta</label>
                <input type="date" v-model="to_date" class="form-control inputCreate" id="to_date">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="from_rank" class="form-label">Rango Desde</label>
                <input type="number" v-model="from_rank" class="form-control inputCreate" id="from_rank">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="to_rank" class="form-label">Rango Hasta</label>
                <input type="number" v-model="to_rank" class="form-control inputCreate" id="to_rank">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="address" class="form-label">Dirección</label>
                <input type="email" v-model="address" class="form-control inputCreate" id="address">
              </div>
            </div>            
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Codigo Postal</label>
                <input type="number" v-model="zip_code" class="form-control inputCreate" id="zip_code">
              </div>
            </div>
            <div class="col-md-3">
              <label for="nombre_comun" class="form-label">Pais</label>
              <Select  v-model="selectedCountry" @change="selectContryCode" optionValue="codigo_numerico" :options="contry" filter optionLabel="nombre_comun" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="code_contry" class="form-label">Codigo Pais</label>
                <input type="number" :value="selectedCodeCountry" class="form-control inputCreate"  disabled id="code_contry">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="selectedDeparment" class="form-label">Departamento</label>
              <Select  v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" optionValue="codigo" filter optionLabel="departamento" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="ciudad_municipio" class="form-label">Codigo Departamento</label>
                <input type="number" :value=selectedCodeDeparment class="form-control inputCreate" disabled  id="ciudad_municipio">
              </div>
            </div>
            <div class="col-md-3">
              <label for="selectedMunicipaly" class="form-label">Municipio</label>
              <Select  v-model="selectedMunicipaly" @change="selectedCodeMun" optionValue="codigo" :options="municipalities" filter optionLabel="municipio" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="rangeTo_number" class="form-label">Codigo Municipio</label>
                <input type="number" :value="selectedCodeMunicipaly" class="form-control inputCreate" disabled  id="rangeTo_number">
              </div>
            </div>
          </div>
        </div>
        <template #footer>
            <Button label="Cancel" text severity="danger" @click="modalUpdate = false" autofocus />
            <Button label="Actualizar" outlined severity="primary" @click="update" autofocus />
        </template>
      </Dialog>
      
    </div>
  </div>
</template>

<style scoped>

.inputCreate {
  height: 3rem !important;
}
</style>
